export default __webpack_public_path__ + "static/media/NW0040.34I-39544_-25360_0.82116e37.jpg";